export type FofocaStoryMedia = 'image' | 'video';

/** Which story-media tab Gossip should show. An explicit choice wins;
 *  otherwise a leftover filler playlist (or randomize flag) infers Video. */
export function resolveFofocaStoryMedia(config: object): FofocaStoryMedia {
  const media = config as {
    storyMedia?: string | null;
    fillerUrl?: string | null;
    fillerUrls?: Array<string | null> | null;
    fillerRandomize?: boolean | null;
    imageUrl?: string | null;
  };
  if (media.storyMedia === 'image' || media.storyMedia === 'video') return media.storyMedia;
  if (media.fillerRandomize) return 'video';
  const hasFiller = Boolean(media.fillerUrl)
    || (media.fillerUrls ?? []).some(Boolean);
  return hasFiller ? 'video' : 'image';
}
